import FAQ from "./FAQ";
import { useState } from "react";

export default function FAQSection(props) {
    const [FAQs, setFAQs] = useState([

        {
            id: 1,
            question: "What is TECHNOGRAD?",
            answer: "TECHNOGRAD is a coding event designed by DJS-NSDC to showcase your coding skills, promote innovation, and foster collaboration.",
            open: false
        },

        {
            id: 2,
            question: "What to expect in the TECHNOGRAD Event?",
            answer: "The clock is ticking, and the excitement is building. Get ready to embark on an adventure like no other. There will be 4 segments: The Quiz Battle, the Debugging Challenge, Minute to Win it, and the surprise Grand Finale.",
            open: false
        },
        {
            id: 3,
            question: "When and where is the TECHNOGRAD event taking place?",
            answer: "The event is scheduled for the 15th and 16th of September at Dwarkadas J Sanghvi College of Engineering, Vile Parle.",
            open: false
        },

        {
            id: 4,
            question: "How do I register for the TECHNOGRAD event?",
            answer: "You can register for the event using the forms link on the top of this page.",
            open: false
        },

        {
            id: 5,
            question: "Who can participate in TECHNOGRAD?",
            answer: "TECHNOGRAD is open to SE's and TE's. Participants from all branches and skill levels are welcomed. FE’s are also welcomed and encouraged to join as an audience.",
            open: false
        },

        {
            id: 6,
            question: "Can I participate as an individual or do I need to be part of a team?",
            answer: "TECHNOGRAD offers only team-based participation options. A team can have a maximum of 4 players.",
            open: false
        },
        {
            id: 7,
            question: "Is there any prerequisite required?",
            answer: "The participants must have an adequate knowledge of coding and debugging the errors. ",
            open: false
        },
        {
            id: 8,
            question: "What should I bring with me to the coding event?",
            answer: "Participants should bring their own laptops or devices, chargers, and any necessary coding tools or software. Specific requirements will be outlined in the event guidelines.",
            open: false
        },
        {
            id: 9,
            question: "What is the Coding Quiz Battle?",
            answer: "The Coding Quiz Battle is an interactive competition that tests participants' coding knowledge and problem-solving skills under pressure through a series of questions.",
            open: false
        },
        {
            id: 10,
            question: "What is the concept behind the Debugging Challenge?",
            answer: "Each team will be presented with a code that contains errors, and they must identify and fix those errors to make the code work correctly.",
            open: false
        },

        {
            id: 11,
            question: "What can I anticipate during the \"Minute to Win It\" segment??",
            answer: "The \"Minute to Win It\" segment is a fun and fast-paced competition where participants have one minute to complete coding challenges or tasks to earn points and win exciting prizes.",
            open: false
        },
        {
            id: 12,
            question: "Why should I look forward to the TECHNOGRAD event?",
            answer: "As passionate seekers of adventure, we invite you to sharpen your wits, dust off your explorer's hat, and prepare for an unforgettable quest. The path will be filled with enigmatic clues, puzzling conundrums, and the promise of glorious rewards.",
            open: false
        },
        {
            id: 13,
            question: "Why should I participate in this event?",
            answer: "It's a thrilling event that will put your coding skills to the test. Can you code fast enough to beat the clock and win the game? Find out now!",
            open: false
        },
        {
            id: 14,
            question: "How can I stay updated on event details and announcements?",
            answer: "Stay informed about event updates, schedules, and announcements by regularly checking our event website and by following our Instagram page https://www.instagram.com/djs.nsdc/",
            open: false
        },
    ]);

    const toggleFAQ = (index) => {
        setFAQs(
            FAQs.map((faq, i) => {
                if (i === index) {
                    faq.open = !faq.open;
                } else {
                    faq.open = false;
                }
                return faq;
            })
        );
    };

    return (
        <section className="tg23-faqs-wrapper">
            <p className="tg23-section-heading" data-value="FAQ's" onMouseOver={props.mouseHover}>FAQ's</p>
            <div className="tg23-faqs">
                {FAQs.map((faq, i) => (
                    <FAQ key={i} faq={faq} index={i} toggleFAQ={toggleFAQ} />
                ))}
            </div>
        </section>
    );
}
